import {gql } from "@apollo/client";

export const GET_HISTORICAL_ADVICES= gql`

query GetHistoricalAdvices($startDate: String!, $endDate: String!) {
  getHistoricalAdvices(startDate: $startDate, endDate: $endDate) {
    dt_close_date
    dt_entry_time
    dt_open_date
    dt_exit_time
    s_status
    s_symbol
    n_pl
  }
}
`

export const GET_ALL_TRADES=gql`

query GetTrades($username: String!, $tradeCategory: AdviceType!, $tab: String!, $startIndex: Float) {
  getTrades(username: $username, trade_category: $tradeCategory, tab: $tab, startIndex: $startIndex) {
    
    dt_close_date
    dt_date
    dt_entry_time
    dt_exit_time
    dt_expiry_date
    j_dividend {
      date
      value
    }
    j_m2m {
      date
      value
    }
    j_target_stoploss {
      s_code
      s_symbol
      time
      Target
      Stoploss
    }
    model_section
    n_exit_price
    n_pl
    n_pl_rs
    n_return
    n_return_after_cost
    n_strike_price
    n_transaction
    s_code
    s_option_type
    trade_category
    s_status
    s_symbol
    s_trade_type
    pl_with_dividend
    oneDayPl          
    oneDay_return_per
    n_id
  }
}`

export const GET_TOTAL_TRADES=gql`

query GetTotalTrades($username: String!) {
  getTotalTrades(username: $username) {
    
    dt_close_date
    dt_date
    dt_entry_time
    dt_exit_time
    dt_expiry_date
    model_section
    n_exit_price
    n_pl
    n_pl_rs
    n_return
    n_return_after_cost
    n_strike_price
    n_transaction
    s_code
    s_option_type
    trade_category
    s_status
    s_symbol
    s_trade_type
    pl_with_dividend
    oneDayPl          
    oneDay_return_per
    n_id
  }
}`

export const GET_USER_PRIVILEGES=gql`

query PrivilegedItem($userName: String!) {
  privilegedItem(userName: $userName) {
    s_code
  }
}
`

export const GET_NOTIFICATION_ENABLED_CODE = gql`

query NotificationCodes($userName: String!) {
  notificationCodes(userName: $userName) {
    s_code
    s_notificationenabled
  }
}
`;


export const GET_ALL_MODEL_CODES = gql`

query AllCodes($userName: String!) {
  allCodes(userName: $userName) {
    s_code
    tradeCode
  }
}
`;

export const GET_ONLY_TARGET_STOPLOSS = gql`
query GetOnlyTS($dtDate: String!, $dtEntryTime: String!, $sCode: String!) {
  getOnlyTS(dt_date: $dtDate, dt_entry_time: $dtEntryTime, s_code: $sCode) {
    s_symbol
    s_code
    s_option_type
    n_strike_price
    dt_entry_time
    dt_exit_time
    dt_date
    dt_expiry_date
    s_status
    j_target_stoploss {
      time
      target
      stoploss
    }
    j_dividend {
      date
      value
    }
    hedgeBaseTransactionPrice
    hedgeCompareTransactionPrice
    model_type
    n_id
  }
}
`;


export const GET_M2M_ARRAY  = gql`
query Query($uniqueId: String!) {
  getM2MArray(uniqueId: $uniqueId) {
    uniqueId
    m2mArray
  }
}
`

export const GET_TRADE_COUNT =gql`
query GetTradeCount($userName: String!) {
  getTradeCount(userName: $userName) {
    EQ
    EqN50plus
    FNO
    LFT
    OPT_LONG
    EqBANK
    EqIT
  }
}
`